import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LoaderScreen } from "@/components/BrandLoader";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    if (!m) return navigate("/", { replace: true });
    api.post("/auth/session", { session_id: m[1] })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [navigate, setUser]);

  return <LoaderScreen label="Signing you in" testid="auth-callback" />;
}
